module.exports = __webpack_public_path__ + "img/jellybean_volt.347ece71.png";